import rootReducer from '../reducers';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);

export default (initialState) => {
  return createStoreWithMiddleware(rootReducer, initialState);
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js